<template>
  <div class="dict">
    <el-form :model="formData" :rules="rules" ref="formData" label-width="100px">
      <el-collapse v-model="activeNames" class="collapse-main-content">
        <el-collapse-item name="5">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>{{ this.$t('inventoryTransfer.form.title') }}
            </div>
          </template>
          <div class="collapse-content">
            <el-row>
              <el-col :span="6">
                <el-form-item :label="this.$t('inventoryTransfer.form.outboundNo')">
                  <el-input v-model="formData.allotNo" :disabled="true"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('inventoryTransfer.form.outboundCreatePerson')">
                  <el-input v-model="formData.allotCreatePersonName" :disabled="true"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('inventoryTransfer.form.outboundStatus')">
                  <el-input v-model="requestStatusData[formData.allotStatus - 1]" :disabled="true">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('inventoryTransfer.form.companyName')">
                  <el-input v-model="formData.allotCompanyName" :disabled="true"> </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item :label="this.$t('inventoryTransfer.form.departmentName')">
                  <el-input v-model="formData.allotDepartmentName" :disabled="true"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('inventoryTransfer.form.outboundCreateDate')">
                  <el-date-picker
                    style="width: 100%"
                    v-model="formData.allotCreateDate"
                    :disabled="true"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('inventoryTransfer.form.allotDate')">
                  <el-date-picker
                    style="width: 100%"
                    v-model="formData.allotDate"
                    :disabled="true"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('inventoryTransfer.form.outboundPrintTime')">
                  <el-date-picker
                    style="width: 100%"
                    :disabled="true"
                    :placeholder="this.$t('inventoryTransfer.form.outboundPrintTimePlaceholder')"
                  >
                    value-format="yyyy-MM-dd" format="yyyy-MM-dd" >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item name="1">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>{{ this.$t('inventoryTransfer.form.info') }}
            </div>
          </template>
          <div class="collapse-content">
            <el-row>
              <el-col :span="6">
                <el-form-item
                  prop="outboundCreateTime"
                  :label="this.$t('inventoryTransfer.form.outboundCreateTime')"
                >
                  <el-date-picker
                    style="width: 100%"
                    v-model="formData.allotDate"
                    :disabled="canEdit"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!-- 调出方式 -->
              <el-col :span="6">
                <el-form-item prop="outIsDirectDeliver" label="调出方式">
                  <el-select
                    style="width: 100%"
                    v-model="formData.outIsDirectDeliver"
                    :disabled="canEdit"
                    @change="isDirectDeliverChange"
                    clearable
                    filterable
                  >
                    <el-option label="直拨" value="1"></el-option>
                    <el-option label="非直拨" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 调入方式 -->
              <el-col :span="6">
                <el-form-item prop="inIsDirectDeliver" label="调入方式">
                  <el-select
                    style="width: 100%"
                    v-model="formData.inIsDirectDeliver"
                    :disabled="canEdit"
                    @change="isDirectDeliverChange"
                    clearable
                    filterable
                  >
                    <el-option label="直拨" value="1"></el-option>
                    <el-option label="非直拨" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="allotOutStorage"
                  :label="this.$t('inventoryTransfer.form.outboundStorageNo')"
                >
                  <el-input v-model="formData.allotOutStorage" :disabled="canEdit"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="allotInStorage"
                  :label="this.$t('inventoryTransfer.form.inboundStorageNo')"
                >
                  <el-input v-model="formData.allotInStorage" :disabled="canEdit"> </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item :label="this.$t('inventoryTransfer.form.contactPerson')">
                  <el-input v-model="formData.nameVoyageLicense" :disabled="canEdit"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="allotDate"
                  :label="this.$t('inventoryTransfer.form.outboundCreateTime')"
                >
                  <el-date-picker
                    style="width: 100%"
                    v-model="formData.allotDate"
                    :disabled="canEdit"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :placeholder="this.$t('inventoryTransfer.form.outboundCreateTimePlaceholder')"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="allotType"
                  :label="this.$t('inventoryTransfer.form.outboundType')"
                >
                  <el-select
                    style="width: 100%"
                    v-model="formData.allotType"
                    :disabled="canEdit"
                    filterable
                    placeholder=""
                  >
                    <el-option
                      v-for="item in allotTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="allotMethod"
                  :label="this.$t('inventoryTransfer.form.deliveryMethod')"
                >
                  <el-select
                    style="width: 100%"
                    v-model="formData.allotMethod"
                    :disabled="canEdit"
                    filterable
                    placeholder=""
                  >
                    <el-option
                      v-for="item in deliveryTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col>
                <el-form-item
                  prop="deliveryNote"
                  :label="this.$t('inventoryTransfer.form.deliveryNote')"
                >
                  <el-input
                    v-model="formData.allotMark"
                    :disabled="canEdit"
                    type="textarea"
                    :rows="3"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>{{ this.$t('inventoryTransfer.form.goodInfo') }}
            </div>
          </template>
          <div class="collapse-content">
            <div class="tableStyle">
              <vxe-grid
                border
                show-overflow
                resizable
                ref="goodTable"
                class="vxe-table-element"
                size="mini"
                align="center"
                :auto-resize="true"
                :data="rowData.goodTable"
                :edit-rules="formData.allotStatus == '3' ? goodRulesConfirm : goodRules"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                :valid-config="{ autoPos: true, message: 'inline' }"
              >
                <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
                <vxe-table-column
                  type="index"
                  width="60"
                  :title="$t('table.index')"
                ></vxe-table-column>
                <vxe-table-column
                  field="preAllotBatchNo"
                  width="200"
                  :title="$t('inventoryTransfer.form.good.businessInboundBatchNo')"
                >
                </vxe-table-column>
                <vxe-table-column
                  field="proAllotBatchNo"
                  width="160"
                  :title="$t('inventoryTransfer.form.good.outboundBatchNo')"
                >
                </vxe-table-column>
                <vxe-table-column
                  field="contractNo"
                  width="160"
                  :title="$t('inventoryTransfer.form.good.contractNo')"
                >
                </vxe-table-column>
                <vxe-table-column
                  field="projectNo"
                  width="160"
                  :title="$t('inventoryTransfer.form.good.projectNo')"
                >
                </vxe-table-column>
                <!-- <vxe-table-column
                  field="settleBatchNewNo"
                  width="160"
                  :title="$t('inventoryTransfer.form.good.settlendBatchNo')"
                /> -->
                <vxe-table-column
                  field="distributionBatchNo"
                  width="100"
                  :title="$t('inventoryTransfer.form.good.distributionBatchNo')"
                />
                <vxe-table-column
                  field="productDetailNo"
                  width="160"
                  :title="$t('inventoryTransfer.form.good.productNo')"
                />
                <vxe-table-column
                  field="productName"
                  width="160"
                  :title="$t('inventoryTransfer.form.good.productName')"
                />
                <vxe-table-column
                  field="partnerName"
                  width="160"
                  :title="$t('inventoryTransfer.form.good.suppiler')"
                />
                <vxe-table-column
                  field="allotUnitName"
                  width="160"
                  :title="$t('inventoryTransfer.form.good.productUnit')"
                />
                <vxe-table-column :title="$t('inventoryTransfer.form.good.businessOrder')">
                  <vxe-table-column
                    field="allotOutAmount"
                    width="160"
                    :title="$t('inventoryTransfer.form.good.businessOrderQuantity')"
                  >
                    <template v-slot="{ row }">{{
                      $baseRequest.formatTableColumn(row.allotOutAmount, $globalVar.qPoint)
                    }}</template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="allotOutPackage"
                    width="160"
                    :title="$t('inventoryTransfer.form.good.businessOrderPackage')"
                  >
                    <template v-slot="{ row }">{{
                      $baseRequest.formatTableColumn(row.allotOutPackage, $globalVar.qPoint)
                    }}</template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="confirmAllotOutAmount"
                    width="160"
                    :title="$t('inventoryTransfer.form.good.ensureOutQuantity')"
                  >
                    <template v-slot="{ row }">{{
                      $baseRequest.formatTableColumn(row.confirmAllotOutAmount, $globalVar.qPoint)
                    }}</template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="confirmAllotOutPackage"
                    width="160"
                    :title="$t('inventoryTransfer.form.good.ensureOutPackage')"
                  >
                    <template v-slot="{ row }">{{
                      $baseRequest.formatTableColumn(row.confirmAllotOutPackage, $globalVar.qPoint)
                    }}</template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="actualAllotOutAmount"
                    width="160"
                    :title="$t('inventoryTransfer.form.good.logisticsOutQuantity')"
                  >
                    <template v-slot="{ row }">{{
                      $baseRequest.formatTableColumn(row.actualAllotOutAmount, $globalVar.qPoint)
                    }}</template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="actualAllotOutPackage"
                    width="160"
                    :title="$t('inventoryTransfer.form.good.logisticsOutPackage')"
                  >
                    <template v-slot="{ row }">{{
                      $baseRequest.formatTableColumn(row.actualAllotOutPackage, $globalVar.qPoint)
                    }}</template>
                  </vxe-table-column>
                </vxe-table-column>
                <vxe-table-column :title="$t('inventoryTransfer.form.good.storageShouldSend')">
                  <vxe-table-column
                    field="allotInAmount"
                    width="160"
                    :title="$t('inventoryTransfer.form.good.storageShouldSendQuantity')"
                  >
                    <template v-slot="{ row }">{{
                      $baseRequest.formatTableColumn(row.allotInAmount, $globalVar.qPoint)
                    }}</template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="allotInPackage"
                    width="160"
                    :title="$t('inventoryTransfer.form.good.storageShouldSendPackage')"
                  >
                    <template v-slot="{ row }">{{
                      $baseRequest.formatTableColumn(row.allotInPackage, $globalVar.qPoint)
                    }}</template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="confirmAllotInAmount"
                    width="160"
                    :title="$t('inventoryTransfer.form.good.storageSendQuantity')"
                  >
                    <!-- <template v-slot:edit="{ row }">
                                    <input-number-ad
                                        v-model="row.confirmAllotInAmount"
                                        :max ="row.allotOutAmount>row.allotInAmount?row.allotOutAmount:row.allotInAmount"
                                        :precision="$globalVar.qPoint"
                                    ></input-number-ad>
                                </template> -->
                    <template v-slot="{ row }">{{
                      $baseRequest.formatTableColumn(row.confirmAllotInAmount, $globalVar.qPoint)
                    }}</template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="confirmAllotInPackage"
                    width="160"
                    :title="$t('inventoryTransfer.form.good.storageSendPackage')"
                  >
                    <!-- <template v-slot:edit="{ row }">
                                    <input-number-ad
                                        v-model="row.confirmAllotInPackage"
                                        :max ="row.allotOutPackage>row.allotInPackage?row.allotOutPackage:row.allotInPackage"
                                        :precision="6"
                                    ></input-number-ad>
                                </template> -->
                    <template v-slot="{ row }">{{
                      $baseRequest.formatTableColumn(row.confirmAllotInPackage, $globalVar.qPoint)
                    }}</template>
                  </vxe-table-column>
                </vxe-table-column>
                <vxe-table-column
                  field="businessAllotUnitPrice"
                  width="160"
                  :title="$t('inventoryTransfer.form.good.nameVoyageLicense')"
                >
                  <template v-slot="scope">
                    {{
                      $baseRequest.formatTableColumn(
                        scope.row.businessAllotUnitPrice,
                        $globalVar.pPoint
                      ) || 0
                    }}
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="businessAllotTotalPrice"
                  width="160"
                  :title="$t('inventoryTransfer.form.good.warehouseReceiptsNo')"
                >
                  <template v-slot="scope">
                    {{ $baseRequest.formatTableColumn(scope.row.businessAllotTotalPrice) || 0 }}
                  </template>
                </vxe-table-column>
              </vxe-grid>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item name="4">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>{{ this.$t('inventoryTransfer.form.transportInfo') }}
            </div>
          </template>
          <div class="collapse-content">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item
                  prop="shippingMethod"
                  :label="this.$t('inventoryTransfer.form.shippingMethod')"
                  label-width="70px"
                >
                  <el-select
                    style="width: 100%"
                    v-model="formData.deliveryMethod"
                    :disabled="canEdit"
                    filterable
                    placeholder=""
                  >
                    <el-option
                      v-for="item in deliveryMethodList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 运输信息表格 -->
            <div class="tableStyle">
              <vxe-grid
                border
                show-overflow
                resizable
                ref="transportTable"
                class="vxe-table-element"
                size="mini"
                align="left"
                :auto-resize="true"
                :data="rowData.transportTable"
                :edit-config="editConfig"
                :valid-config="{ autoPos: true, message: 'inline' }"
              >
                <vxe-table-column type="checkbox" width="60"></vxe-table-column>
                <vxe-table-column
                  type="index"
                  width="60"
                  :title="$t('table.index')"
                ></vxe-table-column>
                <vxe-table-column
                  field="nameVoyageLicense"
                  :title="$t('inventoryTransfer.form.transport.nameVoyageLicense')"
                  :edit-render="{ name: 'input' }"
                ></vxe-table-column>
                <vxe-table-column
                  field="freightInformation"
                  :title="$t('inventoryTransfer.form.transport.freightInformation')"
                  :edit-render="{ name: 'input' }"
                >
                </vxe-table-column>
                <vxe-table-column
                  field="contactPerson"
                  :title="$t('inventoryTransfer.form.transport.contactPerson')"
                  :edit-render="{ name: 'input' }"
                >
                </vxe-table-column>
                <vxe-table-column
                  field="contactPhoneNo"
                  :title="$t('inventoryTransfer.form.transport.contactPhoneNo')"
                  :edit-render="{ name: 'input' }"
                >
                </vxe-table-column>
                <vxe-table-column
                  field="identityCardNumber"
                  :title="$t('inventoryTransfer.form.transport.identityCardNumber')"
                  :edit-render="{ name: 'input' }"
                >
                </vxe-table-column>
              </vxe-grid>
            </div>
          </div>
        </el-collapse-item>

        <el-collapse-item name="5">
          <!--上传附件-->
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>
              {{ $t('salesBill.title.uploadFile') }}
            </div>
          </template>
          <div class="collapse-content">
            <div>
              <upload
                ref="upload"
                :isShow="!canEdit"
                defaultPath="scm/inventoryTransfer"
                :tableData="attachmentList"
              />
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <div class="fixed-bottom-btnList">
      <!-- this.formData.allotStatus!='0' &&  -->
      <el-button
        v-if="this.formData.allotStatus == '1' || this.formData.allotStatus == '4'"
        type="primary"
        @click="gotoEdit"
        :loading="load"
        class="fixed-bottom-btn"
        >修改</el-button
      >
      <!-- 提交审批 -->
      <el-button
        v-if="this.formData.allotStatus == '1'"
        type="primary"
        @click="commit"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.approval') }}</el-button
      >
      <el-button
        v-if="this.formData.allotStatus == '3'"
        type="primary"
        @click="doWithdraw"
        :loading="load"
        class="fixed-bottom-btn"
        >撤回</el-button
      >
      <el-button
        v-if="this.formData.allotMethod == 'DBFS01'"
        type="primary"
        @click="suresaveTransport"
        :loading="load"
        class="fixed-bottom-btn"
        >运输申请</el-button
      >
      <el-button
        v-if="this.formData.allotStatus == '3'"
        type="primary"
        @click="confirm"
        :loading="load"
        class="fixed-bottom-btn"
        >生效确认</el-button
      >

      <el-button
        v-if="formData.allotStatus == '5'"
        type="primary"
        @click="doReverse"
        :loading="load"
        class="fixed-bottom-btn"
        >冲销</el-button
      >
    </div>
  </div>
</template>
<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  // import SearchModal from '@/components/SearchModal';
  import DataBaseAPI from '@/api/dataBase';
  import formRules from './rules/rules';
  // import column from './columns/columns';
  import API from '@/api/wareHouse/inventoryTransfer';
  // import inputNumberAd from '@/components/form-item/input-number-advance';
  import upload from '@/components/upload';
  import XEUtils from 'xe-utils';
  export default {
    components: {
      // SearchModal,
      // inputNumberAd,
      upload,
    },
    name: 'inventoryTransferDetail',
    data() {
      // let newDate = new Date();
      return {
        attachmentList: [],
        requestStatusData: ['已保存', '审批中', '调拨中', '已撤销', '调拨完成', '已冲销'],
        load: false,
        canEdit: true,
        rules: formRules.formRules,
        flag: this.$route.query.flag,
        allotTypeList: [],
        deliveryMethodList: [],
        deliveryTypeList: [],
        goodRules: formRules.goodRules,
        goodRulesConfirm: formRules.goodRulesConfirm,
        tableToolbar: {},
        editConfig: {},
        activeNames: ['1', '2', '3', '4', '5'], //默认展开那些面板，
        formData: {},
        rowData: {
          goodTable: [],
          transportTable: [],
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    mounted() {
      let userInfo = this.userInfo.userInfo;
      this.formData.allotCreatePersonName = userInfo.userName;
      this.formData.allotCreatePersonNo = userInfo.userCode;
      this.formData.allotCompanyNo = userInfo.companyCode;
      this.formData.allotCompanyName = userInfo.companyName;
      this.formData.allotDepartmentNo = userInfo.departmentCode;
      this.formData.allotDepartmentName = userInfo.departmentName;
      this.formData.allotCreateDate = new Date();
      this.formData.allotDate = new Date();
      this.formData.companyCode = userInfo.companyCode;
      this.formData.companyName = userInfo.companyName;
      this.formData.departmentCode = userInfo.departmentCode;
      this.formData.departmentName = userInfo.departmentName;
      this.getDic();
      //控制页面是否可修改
      if (this.$route.query && this.$route.query.id) {
        this.getData(this.$route.query.id);
      }
    },
    methods: {
      //类型
      isDirectDeliverChange() {
        this.$refs.searchModalOut.blurModal();
        this.$refs.searchModalIn.blurModal();
        this.formData.allotOutStorageNo = null;
        this.formData.allotOutStorage = null;
        this.formData.allotInStorage = null;
        this.formData.allotInStorageNo = null;
        this.storageNo = null;
        this.rowData.goodTable = [];
      },

      //提交
      commit() {
        console.log('commit');
        this.$refs.formData.validate((valid) => {
          if (valid) {
            //判断商品数量
            if (!(this.rowData.goodTable && this.rowData.goodTable.length > 0)) {
              this.$message({
                showClose: true,
                message: this.$t('inventoryTransfer.msg.goodNeedMsg'),
                type: 'error',
              });
              return;
            } else {
              this.$refs.goodTable.validate((valid) => {
                if (valid) {
                  this.saveData(2);
                }
              });
            }
          }
        });
      },
      //提交数据
      saveData(status) {
        this.load = true;
        let data = this.formData;
        if (this.$route.query && this.$route.query.id) {
          //data.id = this.$route.query.id
          data.isAdd = false;
        } else {
          data.isAdd = true;
        }
        if (status == 1) {
          data.isSubmit = false;
        } else {
          data.isSubmit = true;
        }
        data.currencyTypeCode = 'CNY';
        data.currencyTypeName = '人民币';
        let userInfo = this.userInfo.userInfo;
        data.tenantCode = userInfo.tenantCode;
        //物流运输信息
        let transportList = [];
        if (this.rowData.transportTable && this.rowData.transportTable.length > 0) {
          this.rowData.transportTable.map((item, index) => {
            item.allotDetailNo = index + 1;
          });
          transportList = this.rowData.transportTable;
        }
        //商品信息
        let goodList = [];
        if (this.rowData.goodTable && this.rowData.goodTable.length > 0) {
          this.rowData.goodTable.map((item, index) => {
            item.allotDetailNo = index + 1;
          });
          goodList = this.rowData.goodTable;
        }
        // ===========sunxueping TAPD[ID1000844]需求增加批次号查重校验逻辑===========
        let batchNoList = goodList.map((item) => {
          return item.preAllotBatchNo;
        });
        if (batchNoList.length > Array.from(new Set(batchNoList)).length) {
          return this.$message({
            showClose: true,
            message: '不同行项目不可重复同一批次号（相同批次号只能在一行）',
            type: 'error',
          });
        }
        // =========================================================================
        data.distributionAllotTransportDTOs = transportList;
        data.storageAllotDetailDTOs = goodList;
        data.attachmentList = XEUtils.clone(this.attachmentList, true);
        this.loading.startLoading();
        let url = status === 2 ? API.SUBMIT_API : API.SAVE_API;
        this.$axios
          .post(url, data)
          .then((res) => {
            this.loading.endLoading();
            if (0 == res.data.code) {
              this.load = false;
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              if (status == 1) {
                this.getData(res.data.data.allotNo);
              } else {
                this.toPath();
              }
            } else {
              this.load = false;
              if (status === 2) {
                if (res.data.data) {
                  this.getData(res.data.data.allotNo);
                }
              }
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          })
          .catch(() => this.loading.endLoading());
      },

      toPath() {
        let path = {
          fromPath: {
            path: '/wareHouse/inventoryTransferAdd',
            name: 'inventoryTransferAdd',
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/wareHouse/inventoryTransferList',
            name: 'inventoryTransferList',
            meta: {
              keepAlive: false,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      // 撤回
      async doWithdraw() {
        let params = {
          //撤回所需参数
          allotNo: this.formData.allotNo,
          version: this.formData.version,
        };
        this.$confirm('是否确认撤回？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            this.loading.startLoading();
            let res = await this.$axios.post(API.REVOKE_API, params);
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.$message({
                showClose: true,
                type: 'success',
                message: res.data.msg,
              });
              this.getData(this.$route.query.id);
            } else {
              this.$message({ showClose: true, type: 'error', message: res.data.msg });
            }
          })
          .catch(() => {
            this.$message({ showClose: true, type: 'info', message: '已取消！' });
          });

        // this.$baseRequest
        //   .doWithdrawCommon(API.REVOKE_API, params)
        //   .then((res) => {
        //     if (res.code == 0) {
        //       this.$message({
        //         showClose: true,
        //         type: 'success',
        //         message: res.msg,
        //       });
        //       this.getData(this.$route.query.id);
        //     } else {
        //       this.$message({ showClose: true, type: 'error', message: res.msg });
        //     }
        //   })
        //   .catch((e) => {
        //     console.log(e);
        //   });
      },
      async doReverse() {
        let params = {
          allotNo: this.formData.allotNo,
          version: this.formData.version,
        };
        let res = await this.$axios.post(API.REVERSE_API, params);
        if (res) {
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: res.data.msg,
            });
            this.getData(this.$route.query.id);
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg,
            });
          }
        }
      },
      getDic() {
        let tenantCode = this.userInfo.userInfo.tenantCode;
        //调拨类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, {
            dictType: 'allot_type',
            tenantCode,
          })
          .then((res) => {
            if (0 == res.data.code) {
              this.allotTypeList = res.data.data;
            }
          });
        //调拨方式
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, {
            dictType: 'allocation_method',
            tenantCode,
          })
          .then((res) => {
            if (0 == res.data.code) {
              this.deliveryTypeList = res.data.data;
            }
          });
        //运输方式
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, {
            dictType: 'delivery_method',
            tenantCode,
          })
          .then((res) => {
            if (0 == res.data.code) {
              this.deliveryMethodList = res.data.data;
            }
          });
      },
      //查询详情
      getData(id) {
        this.$axios.get(API.DETAIL_API, { allotNo: id }).then((res) => {
          if (res.data.code === 0) {
            this.formData = res.data.data;
            this.attachmentList = res.data.data.attachmentList;
            this.rowData.goodTable = this.formData.storageAllotDetailVOs;
            this.rowData.transportTable = this.formData.distributionAllotTransportVOs;
          }
        });
      },
      //跳转到修改界面
      gotoEdit() {
        let path = {
          path: '/wareHouse/inventoryTransferEdit',
          name: 'inventoryTransferEdit',
          meta: {
            keepAlive: true,
          },
          query: { id: this.formData.allotNo },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //生成物流运输单
      saveTransport() {
        let data = {};
        data.tenantCode = this.userInfo.userInfo.tenantCode;
        data.companyCode = this.userInfo.userInfo.companyCode;
        data.companyName = this.userInfo.userInfo.companyName;
        data.departmentCode = this.userInfo.userInfo.departmentCode;
        data.departmentName = this.userInfo.userInfo.departmentName;
        data.deliveryCreatePersonName = this.userInfo.userInfo.userCode;
        data.deliveryCreatePersonNo = this.userInfo.userInfo.userName;
        data.deliveryLoginCompany = this.userInfo.userInfo.companyName;
        data.deliveryType = '3';
        data.transferSlipNo = this.formData.allotNo;
        data.deliveryDepartment = this.userInfo.userInfo.departmentName;
        data.pickupStorageNo = this.formData.allotOutStorageNo;
        data.pickupStorageName = this.formData.allotOutStorage;
        data.shiptoStorageName = this.formData.allotInStorage;
        data.shiptoStorageNo = this.formData.allotInStorageNo;
        data.deliveryStatus = 1;
        let productList = [];
        if (this.rowData.goodTable && this.rowData.goodTable.length > 0) {
          this.rowData.goodTable.map((item) => {
            let obj = {
              deliveryDetailNo: item.allotDetailNo,
              transferSlipNo: item.allotDetailNo,
              providerNo: item.partnerNo,
              providerName: item.partnerName,
              productNo: item.productDetailNo,
              productName: item.productName,
              deliveryQuantity: item.allotOutAmount,
              packageNumber: item.allotOutPackage,
              contractUnit: item.allotUnit,
            };
            productList.push(obj);
          });
        }
        data.deliveryDetailStr = JSON.stringify(productList);
        data.deliveryTransportStr = JSON.stringify(this.rowData.transportTable);
        this.$axios.post(API.SAVE_DELIVERY, data).then((res) => {
          if (0 == res.data.code) {
            //如果操作成功，直接返回列表
            this.$message({
              type: 'success',
              message: this.$t('message.success'),
            });
          } else {
            //如果有错误返回，提示信息
            this.$alert(res.data.msg);
          }
        });
      },
      //生成物流运输单查询校验
      suresaveTransport() {
        let params = {
          transferSlipNo: this.formData.allotNo,
        };
        this.$axios.post(API.CALC_PICK_DELIVERY, params).then((res) => {
          if (res.data.code == 0) {
            if (res.data.data == 0) {
              this.saveTransport();
            } else {
              this.$message({
                showClose: true,
                message: this.$t('inventoryTransfer.msg.transTip'),
                type: 'error',
              });
            }
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //生效确认
      confirm() {
        this.$refs.goodTable.validate((valid) => {
          if (valid) {
            let list = [];
            let data = this.$refs.goodTable.getTableData().fullData;
            if (data && data.length > 0) {
              let flag = true;
              // 调入方式是非直播下需判断物流已入库数量、确认调入数量
              if (this.formData.inIsDirectDeliver == '0') {
                data.map((item) => {
                  if (item.allotInAmount && item.confirmAllotInAmount) {
                    let obj = {
                      id: item.id,
                      version: item.version,
                      confirmAllotInAmount: item.confirmAllotInAmount,
                      confirmAllotInPackage: item.confirmAllotInPackage,
                    };
                    list.push(obj);
                  } else {
                    flag = false;
                  }
                });
              }
              // 调出方式是非直播下需判断物流实出数量、确认调出数量
              if (this.formData.outIsDirectDeliver == '0') {
                data.map((item) => {
                  if (item.actualAllotOutAmount && item.confirmAllotOutAmount) {
                    let obj = {
                      id: item.id,
                      version: item.version,
                      confirmAllotInAmount: item.confirmAllotInAmount,
                      confirmAllotInPackage: item.confirmAllotInPackage,
                    };
                    list.push(obj);
                  } else {
                    flag = false;
                  }
                });
              }
              if (!flag) {
                //如果还没有进行物流入库操作，不能生效确认
                this.$message({
                  type: 'error',
                  message: this.$t('inventoryTransfer.msg.canNotConfirm'),
                });
                return;
              } else {
                //物流已入库数量不等于业务确认调入数量  confirmAllotInAmount
                const listData =
                  data.filter((item) => {
                    return item.confirmAllotInAmount != item.allotInAmount;
                  }) || [];
                //直拨下无需校验物流已入库数量
                if (this.formData.inIsDirectDeliver == '1') {
                  return this.sureConfirm(list);
                }
                if (listData.length > 0) {
                  this.$confirmAction('提示', this.$t('businessReceiptList.message.sureConfirm'))
                    .then(() => {
                      this.sureConfirm(list);
                    })
                    .catch(() => {
                      this.$message({
                        showClose: true,
                        type: 'info',
                        message: this.$t('confirm.cancel'),
                      });
                    });
                } else {
                  this.sureConfirm(list);
                }
              }
            }
            //return
          }
        });
      },
      sureConfirm(list) {
        let params = {
          allotNo: this.formData.allotNo,
          version: this.formData.version,
          storageAllotDetailDTOs: list,
        };
        this.$axios.post(API.CONFIRM_API, params).then((res) => {
          if (0 == res.data.code) {
            //如果操作成功，直接返回列表
            this.$message({
              type: 'success',
              message: this.$t('message.success'),
            });
            let path = {
              fromPath: {
                path: '/wareHouse/inventoryTransferDetail',
                name: 'inventoryTransferDetail',
                meta: {
                  keepAlive: true,
                },
              },
              toPath: {
                path: '/wareHouse/inventoryTransferList',
                name: 'inventoryTransferList',
                meta: {
                  keepAlive: false,
                },
              },
            };
            this.$store.dispatch('tagsView/backTabView', path).then(() => {
              this.$nextTick(() => {
                this.$router.push(path.toPath);
              });
            });
          } else {
            //如果有错误返回，提示信息
            this.$alert(res.data.msg);
          }
        });
      },
    },
    watch: {},
  };
</script>
<style lang="scss" scoped>
  .deliveryOrderTop {
    background-color: #fff;
    margin-bottom: 10px;
    padding: 26px 10px 11px 10px;
  }
</style>
